<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Criar regra para centro de custo: {{ dadosCentro?.code }}
        </p>
        <p class="q-ml-md row col-12 text-h7 text-brand-5 text-weight-bold">
          Selecione a unidade e os centros para criar uma regra
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'grupo-produtos-listar' }">
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row col-2 q-ml-md">
      <lista-unidades-select v-model="unidadeSelect"></lista-unidades-select>
    </div>
    <div class="q-mb-lg">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        title="Selecione o(s) Grupo(s)"
        selection="multiple"
        v-model:selected="selected"
        dense
        v-model:pagination="pagination"
        class="q-mt-md"
        row-key="name"
        hide-pagination
        hide-header
        grid
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:item="props">
          <div
            class="q-pa-xs col-xs-12 col-sm-6 col-md-4 col-lg-3 grid-style-transition"
            :style="selected ? 'transform: scale(0.95);' : ''"
          >
            <q-card class="row align" :class="selected ? 'bg-grey-2' : ''">
              <q-card-section>
                <q-checkbox
                  dense
                  v-model="selected"
                  :val="props.row.id"
                  :label="props.row.name"
                  @click="verProdutos(props.row.id)"
                />

                <span class="q-ml-sm">{{ props.row.code }}</span>
              </q-card-section>
              <q-separator />
            </q-card>
          </div>
        </template>
        <template #body-cell-epi="props">
          <q-td>
            <q-btn v-if="props" round color="positive" icon="headphones" />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <span class="q-table__title">Defina a nova regra </span>
    <div class="row q-mt-md">
      <div class="col-2 col-md-2 q-mt-sm q-ml-sm">
        <q-input
          dense
          outlined
          label="Prazo Mínimo (em dias)"
          v-model="regras.minimo"
          maxlength="4"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-input
          dense
          outlined
          label="Prazo Máximo (em dias)"
          :disable="regras.minimo == ''"
          v-model="regras.maximo"
          maxlength="4"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-input
          dense
          outlined
          label="Quantidade"
          v-model="regras.quantidade"
          maxlength="8"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-input dense outlined label="Descrição" v-model="regras.descricao" />
      </div>
      <!--<div class="col-md-3 col-2 q-mt-sm q-ml-sm">
          <q-select
            :options="tipo"
            dense
            outlined
            label="Tipo de Controle"
            v-model="regras.controle"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>-->
      <!-- <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
          <q-select
            :options="critico"
            dense
            outlined
            label="Critico"
            v-model="regras.critico"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>-->
      <div class="q-mt-sm q-ml-sm">
        <q-btn
          @click="criarRegra"
          color="positive"
          label="Criar Regra"
          class="q-ml-sm"
          no-caps
          icon="done"
        />
      </div>
    </div>

    <div>
      <table-centro-regras :atualizar="atualizar" />
    </div>

    <div>
      <table-produtos-selecionados
        :contratoId="unidade"
        :id="idProdutos"
        :atualizar="getSecondTable"
      />
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";
import TableProdutosSelecionados from "../components/TableProdutosSelecionados.vue";
import TableCentroRegras from "../components/TableCentroRegras.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: {
    TableProdutosSelecionados,
    TableCentroRegras,
    ListaUnidadesSelect,
  },
  props: ["unidades"],
  setup(props) {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const unidadeSelect = ref();
    const disable = ref(true);
    const route = useRoute();
    const unidade = ref("");
    const filtrar = ref("");
    const selected = ref([]);
    const idProdutos = ref("");
    const getSecondTable = ref(0);
    const centroId = route.params.id;
    const atualizar = ref(0);
    const dadosCentro = ref({});
    const regras = ref({
      minimo: "",
      maximo: "",
      quantidade: "",
      descricao: "",
      controle: {
        label: "EMAIL E STATUS TROCA (WEB)",
        value: "ambos",
      },
      critico: {
        label: "Não",
        value: "0",
      },
    });

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 15,
    });
    const getDados = async (page = 0, rowsPerPage = 8) => {
      disable.value = true;
      try {
        let response = await store.dispatch("centroDeCusto/listarGrupos", {
          vendor_id:
            unidade.value == ""
              ? store.state.org.unidadeData.id
              : unidade.value,
          page,
          per_page: rowsPerPage,
          search: filtrar.value,
        });

        rows.value = response.data.results.data;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const getCentro = async () => {
      disable.value = true;
      try {
        let response = await store.dispatch(
          "centroDeCusto/listarCentroEspecifico",
          {
            id: centroId,
          }
        );

        dadosCentro.value = response.data.model;

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getCentro);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const criarRegra = async () => {
      if (selected.value.length == 0) {
        quasar.notify({
          message: "Selecione um grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      selected.value.forEach(async (value) => {
        try {
          await store.dispatch("centroDeCusto/criarRegra", {
            minimum_days: regras.value.minimo,
            maximum_days: regras.value.maximo,
            amount: regras.value.quantidade,
            description: regras.value.descricao,
            group_id: value,
            cost_center_id: centroId,
          });

          quasar.notify({
            message: "Regra adicionada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          regras.value.maximo = "";
          regras.value.minimo = "";
          regras.value.quantidade = "";
          regras.value.critico = "";
          atualizar.value++;
        } catch (error) {
          quasar.notify({
            message:
              "Erro a o definir regra preencha todos os dados ou selecione um centro",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      });
    };

    const verProdutos = async (id) => {
      idProdutos.value = id;
      getSecondTable.value++;
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        unidade.value = store.state.org.unidadeData.id;
        getDados();
      }
    );

    watch(
      () => props.unidades,
      () => {
        unidade.value = "";
        getDados();
      }
    );

    watch([() => regras.value.minimo, () => regras.value.maximo], () => {
      if (Number(regras.value.minimo) > Number(regras.value.maximo)) {
        regras.value.maximo = +regras.value.minimo + 1;
      }
    });

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidadeSelect.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      rows,
      columns,
      getDados,
      unidade,
      pagination,
      handleRequest,
      disable,
      filtrar,
      regras,
      criarRegra,
      verProdutos,
      idProdutos,
      getSecondTable,
      unidadeSelect,
      tipo: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "EMAIL E STATUS TROCA (WEB)",
          value: "ambos",
        },
        {
          label: "NENHUM",
          value: "nenhum",
        },
        {
          label: "SOMENTE EMAIL",
          value: "email",
        },
        {
          label: "SOMENTE STATUS TROCA (WEB)",
          value: "farol",
        },
      ],
      critico: [
        {
          label: "Sim",
          value: "1",
        },
        {
          label: "Não",
          value: "0",
        },
      ],
      selected,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      atualizar,
      centroId,
      dadosCentro,
    };
  },
};
</script>

<style lang="sass">
.grid-style-transition
  transition: transform .28s, background-color .28s
</style>

<style scoped>
.align {
  align-items: center;
}

.pointer {
  cursor: pointer;
}
a {
  text-decoration: none;
}
.texto-titulo {
  font-size: 20px;
}
.icon-voltar {
  font-size: 25px;
}
.container-link-voltar {
  margin-right: 10px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
}
</style>
